import { getErrorMessage } from "../getErrorMessage";
import type { Range, Validator } from "./types";

export const range: Validator = ({
  name,
  answer,
  validation,
  questionErrorMessage,
}) => {
  const { min, max } = validation.value as Range;
  let answerValue: number | string = answer;
  let valid = false;

  // Establish comparison type
  // If min and max are numbers, use number comparison
  if (typeof min === "number" && typeof max === "number") {
    answerValue = Number(answer);
  }

  // If min and max are dates, they should be yyyy-mm-dd format
  valid =
    (answerValue >= min ? true : false) && (answerValue <= max ? true : false);

  return {
    id: name,
    valid,
    message: valid
      ? undefined
      : getErrorMessage({
          validationMessage: validation.message,
          questionErrorMessage,
        }),
  };
};
